import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function SnykConnectForm({ onSubmit, guideMode }) {
  const formInitialValues = {
    api_key: "",
    datacenter_url: "https://api.snyk.io/",
  };
  const formCheckoutSchema = yup.object().shape({
    api_key: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };
  const [showSecret, setShowSecret] = useState(false);
  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          setFieldValue,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <InputLabel>Data Center</InputLabel>
              <Select
                label="Data Center"
                value={values.datacenter_url}
                onChange={(selectedOption) => {
                  setFieldValue("datacenter_url", selectedOption.target.value);
                }}
                disabled={guideMode}
              >
                <MenuItem value={"https://api.snyk.io/"}>
                  Default Datacenter
                </MenuItem>
                <MenuItem value={"https://api.eu.snyk.io/"}>
                  EU Datacenter
                </MenuItem>
                <MenuItem value={"https://api.au.snyk.io/"}>
                  AU Datacenter
                </MenuItem>
              </Select>
              <TextField
                fullWidth
                type={showSecret ? "text" : "password"}
                variant="filled"
                name="api_key"
                label="api_key"
                value={values.api_key}
                onBlur={handleBlur}
                onChange={handleChange}
                autoComplete="off"
                error={!!touched.api_key && !!errors.api_key}
                helperText={touched.api_key && errors.api_key}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
